import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class InvoiceTotalDto {
  @Transform(({ value }) => toEuros(value))
  amount = 0;

  @Transform(({ value }) => toEuros(value))
  vatAmount = 0;

  @Transform(({ value }) => toEuros(value))
  withholdingAmount = 0;

  @Transform(({ value }) => toEuros(value))
  totalAmount = 0;
}
